import React from 'react';

// eslint-disable-next-line 
export const PolicyFormContext = React.createContext();